import axios from 'axios';
import TokenService from './token-service';
import { AIAssistantRequest } from './hooks/ai-assistant-service';

let baseURL = '';

if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  baseURL = 'https://b-line-ai-chatbot-prod-633442958215.us-central1.run.app';
} else {
  baseURL = 'https://b-line-ai-chatbot-dev-633442958215.us-central1.run.app';
}

const aiChatbotInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

aiChatbotInstance.interceptors.request.use(
  (config: any) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const fetchStreamedAIResponse = async (
  payload: AIAssistantRequest,
  onMessageReceived: (message: string) => void
) => {
  const token = TokenService.getLocalAccessToken();
  const url = `${baseURL}/chatbot`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : ''
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error('Failed to fetch the AI Assistant response');
  }

  const reader = response.body?.getReader();
  const decoder = new TextDecoder();

  if (reader) {
    let done = false;
    let accumulatedMessage = '';

    while (!done) {
      const { value, done: readerDone } = await reader.read();
      done = readerDone;

      const chunk = decoder.decode(value, { stream: true });
      accumulatedMessage += chunk;

      // Send the updated message progressively
      onMessageReceived(accumulatedMessage);
    }
  }
};

export default aiChatbotInstance;
